import { useMemo } from 'react';
import { INTEGRATION_STATUS } from '@/lib/constants';
import { INTEGRATIONS } from '../constants/integrations.constants';
import type { Integration } from '../types/integrations.types';
import type { IntegrationsResponse } from '@/types';

/**
 * Hook that merges the static integrations list with actual status from backend
 */
export function useIntegrationsWithStatus(userIntegrations: IntegrationsResponse | undefined): Integration[] {
    return useMemo(() => {
        if (!userIntegrations) return INTEGRATIONS;

        return INTEGRATIONS.map(integration => {
            // Find the integration data from backend
            const integrationData = Object.values(userIntegrations).find(int => int.type === integration.id);

            if (!integrationData) {
                return integration;
            }

            // Determine status: 1 = connected, 2 = error, otherwise disconnected
            let status: 'connected' | 'disconnected' | 'error' = 'disconnected';
            if (integrationData.status === INTEGRATION_STATUS.ACTIVE) {
                status = 'connected';
            } else if (integrationData.status === INTEGRATION_STATUS.ERRORED) {
                status = 'error';
            }

            // Add identifier for Instagram
            let identifier: string | undefined;
            if (integration.id === 'instagram' && integrationData.data) {
                identifier = `@${(integrationData.data as { ig_username?: string }).ig_username}`;
            }

            return {
                ...integration,
                status,
                identifier,
            };
        });
    }, [userIntegrations]);
}
